import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { black1, green } from 'app/components/ThemeProvider/colors';

const CoinsStackedIconSelect = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 20 20" sx={{ height: '20px', width: '20px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M10.8332 4.16667C10.8332 5.08714 8.78114 5.83333 6.24984 5.83333C3.71853 5.83333 1.6665 5.08714 1.6665 4.16667M10.8332 4.16667C10.8332 3.24619 8.78114 2.5 6.24984 2.5C3.71853 2.5 1.6665 3.24619 1.6665 4.16667M10.8332 4.16667V7.88096C9.81525 8.18665 9.1665 8.64911 9.1665 9.16667M1.6665 4.16667V14.1667C1.6665 15.0871 3.71853 15.8333 6.24984 15.8333C7.35786 15.8333 8.37405 15.6904 9.1665 15.4524V9.16667M1.6665 7.5C1.6665 8.42047 3.71853 9.16667 6.24984 9.16667C7.35786 9.16667 8.37405 9.02369 9.1665 8.78571M1.6665 10.8333C1.6665 11.7538 3.71853 12.5 6.24984 12.5C7.35786 12.5 8.37405 12.357 9.1665 12.119M18.3332 9.16667C18.3332 10.0871 16.2811 10.8333 13.7498 10.8333C11.2185 10.8333 9.1665 10.0871 9.1665 9.16667M18.3332 9.16667C18.3332 8.24619 16.2811 7.5 13.7498 7.5C11.2185 7.5 9.1665 8.24619 9.1665 9.16667M18.3332 9.16667V15.8333C18.3332 16.7538 16.2811 17.5 13.7498 17.5C11.2185 17.5 9.1665 16.7538 9.1665 15.8333V9.16667M18.3332 12.5C18.3332 13.4205 16.2811 14.1667 13.7498 14.1667C11.2185 14.1667 9.1665 13.4205 9.1665 12.5"
        stroke={props.color === 'warning' ? green : black1}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default CoinsStackedIconSelect;
